import script from "./EULACard.vue?vue&type=script&setup=true&lang=js"
export * from "./EULACard.vue?vue&type=script&setup=true&lang=js"

import "./EULACard.vue?vue&type=style&index=0&id=77fdfece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77fdfece"]])

export default __exports__